import React from 'react'
import { useAuth } from '../../context/auth'
import { Link, useNavigate } from 'react-router-dom'
import { Navbar, Nav, Container } from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-icons/font/bootstrap-icons.min.css'
import { useTotalOrder } from '../../context/totalorder'

// Dashboard each role lands on from the navbar. Unknown roles fall back to
// the cashier entry, which is what Layout used to do by default.
const ROLE_LINKS = {
  1: { path: '/admin/dashboard', label: 'Admin Dashboard' },
  2: { path: '/cashier/dashboard', label: 'Cashier Dashboard' },
  3: { path: '/user/dashboard', label: 'Dashboard' },
}

const Header = () => {
  const [auth, setAuth] = useAuth()
  const [, setTotalOrder] = useTotalOrder()
  const navigate = useNavigate()

  const user = auth?.user
  const roleLink = user ? ROLE_LINKS[user.role] || ROLE_LINKS[2] : null

  const handleLogout = () => {
    setAuth({
      ...auth,
      user: null,
      token: '',
    })
    setTotalOrder(0)
    localStorage.removeItem('auth')
    localStorage.removeItem('totalorders')

    navigate('/login', { state: { loggedOut: true } })
  }

  return (
    <Navbar
      collapseOnSelect
      expand='lg'
      variant='dark'
      fixed='top'
      style={{ backgroundColor: 'rgb(47, 68, 131)' }}
    >
      <Container fluid className='px-3 px-md-4 app-navbar'>
        <Navbar.Brand
          as={Link}
          to={roleLink ? roleLink.path : '/login'}
          className='fw-bold'
        >
          WMS
        </Navbar.Brand>
        <Navbar.Toggle aria-controls='main-navbar' />
        <Navbar.Collapse id='main-navbar'>
          <Nav className='me-auto'>
            {roleLink && (
              <Nav.Link
                as={Link}
                to={roleLink.path}
                aria-label={roleLink.label}
                title={roleLink.label}
              >
                <i className='bi bi-house-door-fill'></i>
                <span className='d-lg-none ms-2'>{roleLink.label}</span>
              </Nav.Link>
            )}
          </Nav>
          {user && (
            <Navbar.Text className='me-lg-3'>{user.name}</Navbar.Text>
          )}
          <Nav>
            {user ? (
              <Nav.Link
                onClick={handleLogout}
                aria-label='Logout'
                title='Logout'
              >
                <i className='bi bi-box-arrow-right'></i>
                <span className='d-lg-none ms-2'>Logout</span>
              </Nav.Link>
            ) : (
              <Nav.Link as={Link} to='/login'>
                Login
              </Nav.Link>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>

      <style>{`
        .app-navbar .bi {
          font-size: 1.15rem;
          line-height: 1;
          vertical-align: -0.125em;
        }
        .app-navbar .navbar-brand,
        .app-navbar .nav-link,
        .app-navbar .navbar-text {
          color: #fff;
        }
        .app-navbar .nav-link {
          transition: opacity 0.15s ease;
        }
        .app-navbar .navbar-brand:hover,
        .app-navbar .nav-link:hover,
        .app-navbar .nav-link:focus {
          color: #fff;
          opacity: 0.75;
        }
      `}</style>
    </Navbar>
  )
}

export default Header
